/*
 * Copyright (c) 2023 SARL SIGMA POLYNESIA
 */

import { useIntl } from 'react-intl'
import Filter, { FilterableProps } from '../Filter'
import { handleChangeEvent } from '../../../../client/js/lib/form'
import { Radio } from '@mantine/core'

function WithProfessionFilter (props: FilterableProps) {
  const { onChange, value } = props
  const intl = useIntl()
  return (
    <Filter>
      <Radio
        checked={value == null}
        id="with_profession_all_filter"
        label={intl.formatMessage({
          id: 'all',
          defaultMessage: 'Tout'
        })}
        name="withProfession"
        onChange={handleChangeEvent(onChange)}
        value=""
      />
      <Radio
        checked={value === 'true'}
        id="with_profession_filter"
        label={intl.formatMessage({
          id: 'with_profession',
          defaultMessage: 'Avec profession'
        })}
        name="withProfession"
        onChange={handleChangeEvent(onChange)}
        value="true"
      />
      <Radio
        checked={value === 'false'}
        id="without_profession_filter"
        label={intl.formatMessage({
          id: 'without_profession',
          defaultMessage: 'Sans profession'
        })}
        name="withProfession"
        onChange={handleChangeEvent(onChange)}
        value="false"
      />
    </Filter>
  )
}

export default WithProfessionFilter
